<template>
    <div class="economy">

        <box-helper
            headline="Kunder"
            identifier="customers"
        />
        
        <div class="container section">
            <title-block headline="<b>Kunder</b>" class="mb-xl" position="center">
                <p slot="text">
                    Ét samlet overblik over dine kunder
                </p>
            </title-block>

            <!--<view-toggle
                operationsName="Drift"
                operationsLink="CustomersOperations"
                learningName="Udvikling / læring"
                learningLink="CustomersLearning"
                v-if="$route.name === 'CustomersOperations'"
            />-->

            <router-view />
            
        </div>
    </div>
</template>

<script>

export default {
    data () {
        return {
            showHelper: false,
            selectedTable: 'customerTypeRevenue',
            sidebarMenuItems: [
                {
                    name: 'Hvilke kundetyper tjener vi penge på?',
                    tableName: 'customerTypeRevenue'
                }
            ]
        }
    },
    computed: {},
    methods: {
        updateCount (tableName, event) {
            this.counts[tableName] = event
        }
    }
}
</script>



// WEBPACK FOOTER //
// customers.vue?83ee8542